import Axios from 'axios'
import config from '@/config/config.js'
// const baseUrl = 'http://192.168.119.122:8081/api/codetable'
// http://192.168.242.74:8180/swagger-ui.html
const baseUrl = config.apiDomain.ALI + '/ext/esign/signing/'
const addSigningTaskUrl = baseUrl + 'addSigningTask/' // /{formTemplateCode}/{businessCode}/{callBackUrl}  (POST)
const addTaskListSigningTaskUrl = baseUrl + 'addTaskListSigningTaskAli/' // {formCode}/{businessCode}/{signatureFieldName}  (POST)
const buildESignLinkUrl = baseUrl + 'buildESignOAuthUrl/' // Build eSign pdf OAuth info, return eSign URL. (GET)
const fillPdfUrl = baseUrl + 'fillPDF/' // /{formTemplateCode} Fill pdf by basic form.   (POST)
const signByFormCodeUrl = baseUrl + 'signByFormCode/' // /{formCode}/{eSignOAuthCode} Sign by single formCode.  (GET)
const signByStaffCodeUrl = baseUrl + 'signByStaffCode/' // /{eSignOAuthCode} Sign by staffCode.  (GET)
const countSigningCartItemUrl = baseUrl + 'countSigningCartItems'
const removeSigningTaskUrl = baseUrl + 'removeSigningTask/' // {formCode} (post)
const isSigningCartEmptyUrl = baseUrl + 'isSigningCartEmpty' // check signing cart empty or not.

const WAIT_FOR_CHECKING_SINGING_CART = 1 * 1000

// /{businessCode} Start a workflow by automatically finding next staff
// /{businessCode}/{assignedToStaffCode}  Start a workflow
// const startWorkflowUrl = baseUrl + 'startWorkflow/'

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {
  signByFormCodeUrl,

  buildEsignLink (cb, callBackUrl) {
    Axios.get(buildESignLinkUrl + callBackUrl).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  signByStaffCode (cb, eSignAuthorizationCode) {
    Axios.post(signByStaffCodeUrl + eSignAuthorizationCode).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  signByFormCode (cb, formCode, eSignAuthorizationCode) {
    Axios.get(signByFormCodeUrl + formCode + '/' + eSignAuthorizationCode).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  fillPdf (cb) {
    Axios.post(fillPdfUrl).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  addSigningTask (cb, form, formTemplateCode, businessCode, callBackUrl) {
    Axios.post(addSigningTaskUrl + formTemplateCode + '/' + businessCode + '/' + callBackUrl, form).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  addTaskListSigningTask (cb, formCode, businessCode, signatureFieldName, commentFieldName, body) {
    Axios.post(addTaskListSigningTaskUrl + formCode + '/' + businessCode + '/' + signatureFieldName + '/' + commentFieldName, JSON.stringify(body)).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  removeSigningTask (cb, formCode) {
    Axios.post(removeSigningTaskUrl + formCode).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  countSigningCartItem (cb) {
    Axios.get(countSigningCartItemUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error.response.data)
      }
    )
  },

  isSigningCartEmpty (cb) {
    Axios.get(isSigningCartEmptyUrl).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
        console.log(error.response.data)
      }
    )
  },

  waitForSigningCartEmpty (cb) {
    this.isSigningCartEmpty(resp => {
      if (resp.data === false) {
        setTimeout(() => { this.waitForSigningCartEmpty(cb) }, WAIT_FOR_CHECKING_SINGING_CART)
      } else {
        cb(resp)
      }
    })
  }

  //   reassignTaskTo (cb, workItemId, staffCode) {
  //     Axios.post(reassignTaskToUrl + workItemId + '/' + staffCode).then(
  //       response => {
  //         cb(response)
  //         // console.log(response.status)
  //       },
  //       error => {
  //         // console.error(error)
  //         cb(error.response)
  //       }
  //     )
  //   }

  //   completeTrainingStep (cb, itemList) {
  //     Axios.post(completeTSUrl, itemList).then(
  //       response => {
  //         cb(response.status)
  //         // console.log(response.status)
  //       },
  //       error => {
  //         console.error(error)
  //         console.error(error.response.data)
  //       }
  //     )
  //   }

}
